import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useParentServiceOrder } from './ParentServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../_helpers/pdfHelpers'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceState = () => React.useContext(Context)
export const usePlace = () => usePlaceState()?.place

const QUERY = gql`
  query Place($id: ID) {
    place(id: $id, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      resume
      insertedAt
      deleted
      enabled
      type
      fieldValues {
        id
        value
        field {
          id
          name
          type
          configuration
        }
      }
    }
  }
`

const PlaceLoader = ({ children }) => {
  const { replies } = useParentServiceOrder()
  const { id } = getReplyValue(findReplyByQuestionId(replies, 1387))

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlaceLoader
